import { TDeviceType } from '@cian/ui-kit';

export enum EPageType {
  Listing = 'listing',
  Card = 'card',
}

export interface IPageState {
  type: EPageType;
  deviceType: TDeviceType;
}
